module.exports = __webpack_public_path__ + "a06dbc95fb2220096830828ab1926a7f.svg";